<div *ngIf="report">
      
    <div [style]="styles.header.page">
      <div [style]="styles.header.text"><b>YOUR STYLE COMBINATIONS</b></div>
  
      <div [style]="styles.header.line"></div>
    </div>
  
    <div [style]="styles.container_padding">
  
      <h2 [style]="styles.general_h2"><b>Interaction of Your Primary Style with Lowest Style</b></h2>
          
      <p [style]="styles.paragraph">Your primary style is 
        <span [style]="styles.highlight">{{ report.primaryCoachingStyle }} </span> and your lowest style is
        <span [style]="styles.highlight">{{ report.leastDevCoachingStyle }}</span>.</p>
  
      <p [style]="styles.paragraph" [innerHtml]="html"></p>

      <h2 [style]="styles.general_h2"><b>Interaction of Your Secondary Style with Lowest Style</b>
      </h2>

      <p [style]="styles.paragraph">Your secondary style is 
        <span [style]="styles.highlight">{{ report.secondaryCoachingStyle }} </span> and your lowest style is
        <span [style]="styles.highlight">{{ report.leastDevCoachingStyle }}</span>.</p>
  
      <p [style]="styles.paragraph" [innerHtml]="htmlCombination"></p>
  
    </div>
  
  </div>